import { tracking } from '@driftt/traffic-control'

const trackEvent = (
  eventName: string,
  props: Record<string, string | number> = {}
) => {
  tracking.trackEvent(eventName, props)
}

export const trackMeetingLinkCopied = () => trackEvent('Meeting Link Copied')

export const trackMeetingDeleted = () => trackEvent('Meeting Deleted')

export const trackMeetingCreated = () => trackEvent('Meeting Created')

export const trackOrgMeetingCreated = () => trackEvent('Org Meeting Created')

export const trackRoutingProblemsBannerDismissed = (
  props: Record<string, string | number>
) => trackEvent('Routing Problems Banner Dismissed', props)

export const trackRoutingProblemsEngaged = (
  props: Record<string, string | number>
) => trackEvent('Routing Problems Modal: User clicked on issue', props)

export const trackMeetingOutcomesChanged = (
  props: Record<string, string | number>
) => trackEvent('Meeting outcome changed', props)
